"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PessoaFisica = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const pessoa_entity_1 = require("./pessoa.entity");
let PessoaFisica = class PessoaFisica extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdPessoa = void (0);
        this.cdNaturalidade = void (0);
        this.cdEscolaridade = void (0);
        this.dtNascimento = void (0);
        this.nrCpf = void (0);
        this.sgOrgaoRg = void (0);
        this.nmMae = void (0);
        this.nmPai = void (0);
        this.tpSexo = void (0);
        this.stEstadoCivil = void (0);
        this.nrRg = void (0);
        this.nrCnh = void (0);
        this.dtValidadeCnh = void (0);
        this.dtPrimeiraHabilitacao = void (0);
        this.tpCategoriaHabilitacao = void (0);
        this.tpRaca = void (0);
        this.lgDeficienteFisico = void (0);
        this.nmFormaTratamento = void (0);
        this.cdEstadoRg = void (0);
        this.dtEmissaoRg = void (0);
        this.blbFingerprint = void (0);
        this.cdConjuge = void (0);
        this.qtMembrosFamilia = void (0);
        this.vlRendaFamiliarPerCapta = void (0);
        this.tpNacionalidade = void (0);
        this.tpFiliacaoPai = void (0);
        this.lgDocumentoAusente = void (0);
        this.pessoa = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_pessoa", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "cdPessoa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_naturalidade", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "cdNaturalidade", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_escolaridade", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "cdEscolaridade", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_nascimento", nullable: true }),
    __metadata("design:type", Date)
], PessoaFisica.prototype, "dtNascimento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_cpf", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nrCpf", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "sg_orgao_rg", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "sgOrgaoRg", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_mae", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nmMae", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_pai", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nmPai", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_sexo", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "tpSexo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "st_estado_civil", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "stEstadoCivil", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_rg", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nrRg", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_cnh", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nrCnh", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_validade_cnh", nullable: true }),
    __metadata("design:type", Date)
], PessoaFisica.prototype, "dtValidadeCnh", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_primeira_habilitacao", nullable: true }),
    __metadata("design:type", Date)
], PessoaFisica.prototype, "dtPrimeiraHabilitacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_categoria_habilitacao", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "tpCategoriaHabilitacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_raca", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "tpRaca", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_deficiente_fisico", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "lgDeficienteFisico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_forma_tratamento", nullable: true, length: 100 }),
    __metadata("design:type", String)
], PessoaFisica.prototype, "nmFormaTratamento", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_estado_rg", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "cdEstadoRg", void 0);
__decorate([
    typeorm_1.Column("date", { name: "dt_emissao_rg", nullable: true }),
    __metadata("design:type", Date)
], PessoaFisica.prototype, "dtEmissaoRg", void 0);
__decorate([
    typeorm_1.Column("blob", { name: "blb_fingerprint", nullable: true }),
    __metadata("design:type", Object)
], PessoaFisica.prototype, "blbFingerprint", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_conjuge", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "cdConjuge", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "qt_membros_familia", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "qtMembrosFamilia", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "vl_renda_familiar_per_capta", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "vlRendaFamiliarPerCapta", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_nacionalidade", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "tpNacionalidade", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_filiacao_pai", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "tpFiliacaoPai", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_documento_ausente", nullable: true }),
    __metadata("design:type", Number)
], PessoaFisica.prototype, "lgDocumentoAusente", void 0);
__decorate([
    typeorm_1.OneToOne(type => pessoa_entity_1.Pessoa, {
        cascade: ['insert', 'update', 'remove']
    }),
    typeorm_1.JoinColumn([{ name: "cd_pessoa", referencedColumnName: "cdPessoa" }]),
    __metadata("design:type", pessoa_entity_1.Pessoa)
], PessoaFisica.prototype, "pessoa", void 0);
PessoaFisica = __decorate([
    typeorm_1.Entity('grl_pessoa_fisica')
], PessoaFisica);
exports.PessoaFisica = PessoaFisica;
